import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * PageHeader — bigger display title + optional eyebrow (kicsi tag a cím fölött, breadcrumb-stílusú)
 * + opcionális accent-pillér a bal oldalon (1 px brand vonal → emeli a focust).
 */
export function PageHeader({
  title,
  subtitle,
  eyebrow,
  actions,
  accent = false,
  className,
}: {
  title: string
  subtitle?: string
  /** Apró tag a cím fölött, pl. "Pénzügyi modul" vagy "2026 június". */
  eyebrow?: string
  actions?: ReactNode
  /** Bal oldali 2px brand-pillér — emeli a section-t. */
  accent?: boolean
  className?: string
}) {
  return (
    <div className={cn('mb-6 flex flex-wrap items-end justify-between gap-3', className)}>
      <div className={cn('relative', accent && 'pl-4')}>
        {accent && (
          <span
            aria-hidden
            className="absolute left-0 top-1 bottom-1 w-[3px] rounded-full bg-gradient-to-b from-brand-500 to-accent-500"
          />
        )}
        {eyebrow && (
          <p className="text-[11px] font-medium uppercase tracking-[0.12em] text-brand-700 dark:text-brand-300 mb-1.5">
            {eyebrow}
          </p>
        )}
        <h1 className="text-2xl sm:text-display-xs font-semibold text-slate-900 dark:text-slate-50 tracking-tightish">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1.5 text-sm text-slate-500 dark:text-slate-400 max-w-2xl">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  )
}
